module.exports = __webpack_public_path__ + "img/cu.89e88662.svg";